import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import moment from 'moment';
import * as fromShared from '../../../shared';
import { IndirectRateCostCenter } from '../../store/indirect-rate-cost-center';
import { environment } from '../../../../environments/environment';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { ResponseStatus, IStatusMessage } from '../../../shared';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { IndirectRateStructure } from '../../store/indirect-rate-structure';
import { IShowErrors } from '../../../shared/errors-sidenav';

@Component({
    selector: 'ef-indirect-rate-cost-center',
    templateUrl: './indirect-rate-cost-center.component.html',
    styleUrls: ['./indirect-rate-cost-center.component.scss'],
    standalone: false
})
export class IndirectRateCostCenterComponent implements OnInit {
    @Input() rates: IndirectRateStructure[];
    @Input() costCenters: SelectItem[];
    @Input() showAdd: boolean;
    private _items: IndirectRateCostCenter[];
    @Input() public set items(value: IndirectRateCostCenter[]) {
        if (this.showAdd === true) {
            this._items = [
                {
                    ...this.addTemplate,
                    Status: {
                        StatusCode: 0,
                        Message: ''
                    }
                }, // empty row for adding }, // empty row for adding
                ...value
            ];
        } else {
            this._items = [...value];
        }
        this.costCenters = value.map(x => ({
            label: x.Costcenterdesc,
            value: x.Costcenterid
        }));
    }
    public get items(): IndirectRateCostCenter[] {
        return this._items;
    }
    @Output() SaveItem = new ReplaySubject<IndirectRateCostCenter[]>(1);
    public editing: IndirectRateCostCenter = {} as IndirectRateCostCenter;
    selected: IndirectRateCostCenter[];
    cloned: { [i: number]: IndirectRateCostCenter } = {};
    dropdownItemHeight = environment.dropdownItemHeight;
    moment: any;
    private addTemplate: IndirectRateCostCenter = {
        id: -1,
        Allocatefacility: null,
        Costcenterdesc: null,
        Costcenterid: -1,
        FRR: null,
        GAR: null,
        M2R: null,
        MHR: null,
        OHR: null,
        Row_Version: '0x0000000000000000',
        Status: {
            Message: '',
            MsgEntityID: null,
            MsgProcessID: null,
            StatusCode: 0
        }
    };
    private _selectedError: IStatusMessage;
    @Input() public set selectedError(value: IStatusMessage) {
        if (!value) {
            return;
        }
        if (this._selectedError && this._selectedError.MsgEntityID) {
            const oldRow = document.getElementById(
                `row-${this._selectedError.MsgEntityID.toString()}`
            );
            if (oldRow) {
                oldRow.classList.remove('highlight');
                oldRow.classList.remove('highlight-warning');
                oldRow.classList.remove('highlight-danger');
            }
        }
        this._selectedError = value;
        if (!(value && value.MsgEntityID)) {
            return;
        }
        const row = document.getElementById(
            `row-${value.MsgEntityID.toString()}`
        );
        this.log.verbose({
            type: 'PostingAccountComponent:selectedError',
            value,
            row
        });
        if (!row) {
            return;
        }
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        row.classList.add('highlight');
        if (value.StatusCode === ResponseStatus.Warning) {
            row.classList.add('highlight-warning');
        }
        if (value.StatusCode === ResponseStatus.Failed) {
            row.classList.add('highlight-danger');
        }
    }
    public get selectedError(): IStatusMessage {
        return this._selectedError;
    }
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    constructor(private log: LoggingService) {
        this.moment = moment;
    }

    ngOnInit() {}

    onRowEditInit(item: IndirectRateCostCenter) {
        this.cloned[item.id] = { ...item };
        this.editing = item;
        this.log.verbose({
            type: 'IndirectRateCostCenterComponent:onRowEditInit',
            item,
            cloned: this.cloned,
            editing: this.editing
        });
        this.selected = fromShared.uniqBy(
            [...(this.selected || []), item],
            x => x.id
        );
    }
    onRowEditSave(item: IndirectRateCostCenter) {
        this.log.verbose({
            type: 'IndirectRateCostCenterComponent:onRowEditSave',
            item,
            cloned: this.cloned,
            selected: this.selected
        });
        item.Status.StatusCode = ResponseStatus.Loading;
        item.Status.Message = 'Saving';
        item.FRR = item.FRR ? Number(item.FRR) : null;
        item.GAR = item.GAR ? Number(item.GAR) : null;
        item.M2R = item.M2R ? Number(item.M2R) : null;
        item.MHR = item.MHR ? Number(item.MHR) : null;
        item.OHR = item.OHR ? Number(item.OHR) : null;

        this.SaveItem.next([item]);
        delete this.cloned[item.id];
        delete this.editing;
    }
    onRowEditCancel(item: IndirectRateCostCenter) {
        const index = this.items.findIndex(x => x.id === item.id);

        if (item.id === -1) {
            this.items.splice(index, 1, { ...this.addTemplate } as any);
        } else {
            if (index >= 0) {
                this.items.splice(index, 1, this.cloned[item.id]);
            }
        }

        this.items = [...this.items];

        delete this.cloned[item.id];
        delete this.editing;
    }
    getRatesForCostCenter(
        item: IndirectRateCostCenter,
        calcType: string
    ): SelectItem[] {
        return (
            this.rates
                // .filter(x => x.Costcenterid === item.Costcenterid)
                .filter(x => x.Calctype === calcType)
                .map(x => ({
                    label: x.Ratepercent.toFixed(2),
                    value: x.Ratepercent
                }))
        );
    }
    findRate(rateType) {
        return this.rates.find(x => x.Calctype === rateType);
    }
    getRateColumns() {
        return fromShared.uniqBy(this.rates, x => x.Calctype).length + 3;
    }
    onStatusClick(item: IndirectRateCostCenter) {
        this.log.verbose({
            type: 'IndirectRateCostCenterComponent:onStatusClick',
            item
        });
        this.ShowError.emit({ open: true, MsgEntityID: item.id.toString() });
    }
}
